"use client";
import React, { useEffect, useMemo, useRef, useState } from "react";
import styles from "./ScrollingBanner.module.css";

export default function ScrollingBanner() {
    const msgs = useMemo(() => ([
        "⚡ Instant Withdrawals!",
        "💰 instant cash back!",
        "💎 VIP players fast track!",
    ]), []);

    const firstRef = useRef(null);
    const [travelPx, setTravelPx] = useState(700); // fallback
    const [duration, setDuration] = useState(25);  // fallback
    const SPEED = 60; // px/s – po želji

    useEffect(() => {
        // Izmeri ukupnu širinu prve trake (uklj. razmake)
        const el = firstRef.current;
        if (!el) return;
        // offsetWidth često precizniji od getBoundingClientRect().width za ovo
        const w = el.scrollWidth || el.offsetWidth;
        setTravelPx(w);
        setDuration(Math.max(10, w / SPEED));
    }, [msgs]);

    const Row = ({ innerRef }) => (
        <div className={styles.content} ref={innerRef}>
            {msgs.map((m, i) => (
                <span key={i} className={styles.item}>{m}</span>
            ))}
        </div>
    );

    return (
        <div className={styles.wrap}>
            <div
                className={styles.track}
                style={{
                    "--travel": `${travelPx}px`,
                    "--duration": `${duration}s`,
                }}
            >
                {/* kopija A */}
                <Row innerRef={firstRef} />
                {/* kopija B (iza A) */}
                <Row />
            </div>
        </div>
    );
}
